'use client';

import React from 'react';

/**
 * Divider component for separating sections in settings panel
 * Using Tailwind CSS for styling
 */
const Divider: React.FC = () => {
return (
    <div className="w-[90%] h-[20px] my-2 bg-white rounded-full shadow-lg mx-auto border border-gray-200 border-3" />
);
};

export default Divider;
